export default __webpack_public_path__ + "static/media/17.99392f3a.jpg";